import React, { useState } from "react";
import { useEffect } from "react";
import {Typography, Box} from "@mui/material";
import Textarea from '@mui/joy/Textarea';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import { colors } from "../../common/pallette/colors";
import { useSelector } from "react-redux";
import { getLicenceStandardsSAComments, saveLicenceStandardsSa } from "../../api/licence";
import { AvatarAndName } from "../../components/AvatarAndName";
import { formatDateTime } from "../../common/StaticExports";
import { baseUrl } from "../../api/config";

const CommentsContents = () => {
    const currentClub = useSelector((state:any) => state.clubDetails);
    const selectedLicenceStandard = useSelector((state:any) =>  state.licence.selectedLicenceStandard);
    const [data, setData]:any = useState({});
    const [isEdited, setIsEdited] = useState(false);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    useEffect(() => {
        const fetchEvidences = async () => {
            try {
                const response = await getLicenceStandardsSAComments({standardsId: selectedLicenceStandard?.id, clubId: currentClub.id});
                setData(response);
            } catch {

            }
        }
        (selectedLicenceStandard?.id !== undefined && selectedLicenceStandard?.id) && fetchEvidences();
    }, [])

    const manageEvaluationChange = (key:any, updatedValue:any) => {
        const tempData = { ...data, [key]: updatedValue };
        setData(tempData);
        setIsEdited(true);
    }

    const saveEvaluation = () => {
        saveLicenceStandardsSa({licenceStandardId: selectedLicenceStandard?.id, clubId: currentClub.id, comment: data?.comment})
        .then((res:any) => {
            setData(res);
        });
        setIsEdited(false);
    }

    return(
        <>
        <Box className={isAdmin ? 'sdCommentsWrapper cursorNotAllowed' : 'sdCommentsWrapper'} onBlur={() => {isEdited && saveEvaluation()}}>
            <JoyCssVarsProvider>
                <Textarea 
                sx={{ borderRadius: '6px', mt: 0, width: '80%', 
                    // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                    '&.Mui-disabled': {
                        '--Textarea-disabledColor': 'black',
                        color: 'black',
                        cursor: 'not-allowed'
                    }, }} 
                disabled={isAdmin ? true : false}
                placeholder='Add comment' minRows={4} maxRows={4}
                value={data?.comment || ''}
                onChange={(e:any) => {manageEvaluationChange('comment', e.target.value)}} />
            </JoyCssVarsProvider>
            <Box className={'SDuserDetailsWrapper'}>
                {
                    data?.comment !== null &&
                    data?.comment !== '' &&
                    data?.firstName != null &&
                    data?.firstName != ''&&
                    <>
                    <AvatarAndName avatarName={data?.firstName ? `${data.firstName} ${data.lastName}` : 'Undefined'}
                    avatarImage={data.avatarPath ? `${baseUrl}/Content${data.avatarPath}` : ''} />
                    <Typography className='fs12' sx={{ ml: '32px', mb: '10px' }}>{formatDateTime(data.updatedDate)}</Typography>
                    </>
                }
            </Box>
        </Box>
        </>
    )
}

export default CommentsContents;